// extracted by mini-css-extract-plugin
export var active = "_fe-7";
export var blink = "_fe-8";
export var dropDownSelector = "_fe-4";
export var dropDownWrapper = "_fe-3";
export var fakeCursor = "_fe-6";
export var fontSizeButton = "_fe-9";
export var formQuillEditor = "_fe-0";
export var pressed = "_fe-a";
export var qlBlank = "_fe-1";
export var textFormattingToolbar = "_fe-2";
export var textToolbarOption = "_fe-5";